import ApplicationSerializer from './application';

export default class CustomUserDocumentTemplateSerializer extends ApplicationSerializer {}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module 'ember-data/types/registries/serializer' {
  export default interface SerializerRegistry {
    'custom-user-document-template': CustomUserDocumentTemplateSerializer;
  }
}
